'use strict';

/**
 * @classname AnchorPopover
 * @classdesc ポップオーバー
 */
export default class AnchorPopover {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--popover
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$popover = $e.closest('.block--popover').find('.block__item');
		this.makeEvent();
		$(window).on('resize', () => this.makeEvent());
	};


	/**
	 * イベント作成
	 *
	 * @memberof AnchorPopover
	 * @return undefined
	 */
	makeEvent() {
		console.log(`${this.constructor.name}.makeEvent`);
		const windowWidth = $(window).width();
		if(windowWidth <= 768) {
			this._$e.on('click', () => this.popover());
		}else{
			this._$e.on('mouseenter', () => this.popoverOn());
			this._$e.on('mouseleave', () => this.popoverOff());
		}
	};


	/**
	 * ポップオーバー判定
	 *
	 * @memberof AnchorPopover
	 * @return undefined
	 */
	popover() {
		console.log(`${this.constructor.name}.popover`);
		if(this._$e.hasClass('on')){
			this.popoverOff();
		}else{
			this.popoverOn();
		}
	};


	/**
	 * ポップオーバーON
	 *
	 * @memberof AnchorPopover
	 * @return undefined
	 */
	popoverOn() {
		console.log(`${this.constructor.name}.popoverOn`);
		this._$e.addClass('on');
		this._$popover.show();
	}


	/**
	 * ポップオーバーOFF
	 *
	 * @memberof AnchorPopover
	 * @return undefined
	 */
	popoverOff() {
		console.log(`${this.constructor.name}.popoverOff`);
		this._$e.removeClass('on');
		this._$popover.hide();
	}
};
